import styled from 'styled-components';

export const USOffersWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  position: relative;
`;
